export const wordFour = [
  {
    id: 1,
    text: "Music",
    response: "Music elevates mood and reduces stress.",
  },
  {
    id: 2,
    text: "Suspend",
    response: "Judges have authority to suspend any court hearing.",
  },
  {
    id: 3,
    text: "Anticipate",
    response:
      "Scientists anticipate major climate change if not acted upon quickly.",
  },
  {
    id: 4,
    text: "Character",
    response: "Playing sports is a way to build character in young people.",
  },
  {
    id: 5,
    text: "Desire",
    response: "Working hard is driven by desire.",
  },
  {
    id: 6,
    text: "Meditation",
    response: "Meditation brings Inner peace.",
  },
  {
    id: 7,
    text: "Curiosity",
    response: "Genuine curiosity leads to knowledge.",
  },
  {
    id: 8,
    text: "Competition",
    response: "Competition helps build self-efficacy.",
  },
  {
    id: 9,
    text: "Nation",
    response:
      "The entire nation is celebrating Neeraj Chopra's Olympic victory.",
  },
  {
    id: 10,
    text: "Compromise",
    response: "It's important not to compromise one's integrity.",
  },
  {
    id: 11,
    text: "Watch",
    response: "A soldier is always watchful on his enemy.",
  },
  {
    id: 12,
    text: "Turn",
    response: "One must not turn back in the face of difficulties.",
  },
  {
    id: 13,
    text: "Never",
    response: "Never be afraid of the odds.",
  },
  {
    id: 14,
    text: "Record",
    response: "Sachin Tendulkar holds the record of most runs in ODIs.",
  },
  {
    id: 15,
    text: "Snake",
    response:
      "Snake venom is used medically to treat arthritis and other diseases.",
  },
  {
    id: 16,
    text: "Elder",
    response: "The elderly are wise and experienced.",
  },
  {
    id: 17,
    text: "Necessity",
    response: "Necessity drives demand.",
  },
  {
    id: 18,
    text: "Traitor",
    response: "Disloyalty to the country is a traitorous act.",
  },
  {
    id: 19,
    text: "Moon",
    response: "Northern lights happens once in a blue moon in Iceland.",
  },
  {
    id: 20,
    text: "Enforce",
    response: "Strict law enforcement reduces crime rates.",
  },
  {
    id: 21,
    text: "Better",
    response: "Skills becomes better with practice.",
  },
  {
    id: 22,
    text: "Dispute",
    response: "Supreme court resolves inter-state disputes.",
  },
  {
    id: 23,
    text: "Complaint",
    response: "One must not leave the ground for complaint in their work.",
  },
  {
    id: 24,
    text: "Energize",
    response: "A good sleep reenergizes the mind and the body.",
  },
  {
    id: 25,
    text: "Harass",
    response: "Workplaces should have strict anti-harassment policies.",
  },
  {
    id: 26,
    text: "Beat",
    response: "One must stay upbeat during failures.",
  },
  {
    id: 27,
    text: "Press",
    response:
      "Freedom of press is mentioned in article 19 of the constitution.",
  },
  {
    id: 28,
    text: "Prove",
    response:
      "The ruling party must prove its majority during the no-confidence motion. ",
  },
  {
    id: 29,
    text: "Slap",
    response: "Dandi march by Gandhi was a slap in the face of Britishers.",
  },
  {
    id: 30,
    text: "Chair",
    response: "Prime Minister chairs the cabinet.",
  },
  {
    id: 31,
    text: "Eagle",
    response: "One should keep an eagle eye on their bad habits.",
  },
  {
    id: 32,
    text: "Mountain",
    response: "Kanchenjunga is the highest mountain peak in India.",
  },
  {
    id: 33,
    text: "Rogue",
    response: "China is a rogue nation under communist rule.",
  },
  {
    id: 34,
    text: "Steal",
    response: "Stealing never brings comfort.",
  },
  {
    id: 35,
    text: "Draw",
    response: "We should draw lessons from past mistakes.",
  },
  {
    id: 36,
    text: "Wild",
    response: "Climate change is a biggest threat to wildlife.",
  },
  {
    id: 37,
    text: "Determination",
    response: "Fierce determination leads to success.",
  },
  {
    id: 38,
    text: "Rose",
    response: "Rose is U.S National flower.",
  },
  {
    id: 39,
    text: "Rank",
    response: "Field Marshal is the highest attainable rank in Indian Army.",
  },
  {
    id: 40,
    text: "Untouchability",
    response: "Untouchability is abolished in Article 17.",
  },
  {
    id: 41,
    text: "Mechanic",
    response:
      "Industrial revolution gave rise to a new working class of mechanics.",
  },
  {
    id: 42,
    text: "Propagate",
    response: "Light propagates without a medium.",
  },
  {
    id: 43,
    text: "Obedience",
    response: "Every citizen should be obedient to the law.",
  },
  {
    id: 44,
    text: "Treat",
    response: "Eqality of treatment before law is mentioned in Article 14.",
  },
  {
    id: 45,
    text: "Steel",
    response: "India is the second-largest producer of steel.",
  },
  {
    id: 46,
    text: "Halt",
    response: "Too many halts deviates the work.",
  },
  {
    id: 47,
    text: "Equipment",
    response:
      "Soldiers at Siachen need modern equipment to survive the harsh weather.",
  },
  {
    id: 48,
    text: "Opinion",
    response: "Opinions of others should be valued.",
  },
  {
    id: 49,
    text: "Market",
    response: "Covid affected the job market in many countries.",
  },
  {
    id: 50,
    text: "Ghost",
    response:
      "Baba Harbhajan Singh is regarded as a ghost soldier of the Indian Army.",
  },
  {
    id: 51,
    text: "Hope",
    response: "One must not lose hope in the darkest of times.",
  },
  {
    id: 52,
    text: "Internet",
    response: "Internet revolutionized communication.",
  },
  {
    id: 53,
    text: "Business",
    response: "Small businesses are the backbone of the economy.",
  },
  {
    id: 54,
    text: "Track",
    response: "One should keep track of their actions.",
  },
  {
    id: 55,
    text: "Out",
    response: "Outstanding results demand extraordinary efforts.",
  },
  {
    id: 56,
    text: "River",
    response: "Rivers shaped civilizations.",
  },
  {
    id: 57,
    text: "Dull",
    response: "Dull child needs extra encouragement and attention.",
  },
  {
    id: 58,
    text: "Apt",
    response: "Ancient temples aptly describe past civilizations.",
  },
  {
    id: 59,
    text: "Happiness",
    response: "Happiness is self made.",
  },
  {
    id: 60,
    text: "Help",
    response: "Calm mind helps in good performance.",
  },
];
